export default __webpack_public_path__ + "static/media/slide6.2aff968f.svg";